module.exports = __webpack_public_path__ + "static/img/337_TO8_2599_og.97a86d2.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/337_TO8_2599_og.jpg
// module id = WfYX
// module chunks = 0